.navButton {
  height: 48px;
  background: #000;
  border-radius: 0;
  justify-content: flex-start;
  padding: 12px;

  svg {
    fill: #fff;
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }

  .buttonLabel {
    padding-left: 12px;
  }

  &:hover,
  &:focus-visible {
    background: #222;
  }

  &.small {
    width: 46px;
    padding-right: 10px;
    justify-content: center;
  }
}
